export default __webpack_public_path__ + "static/media/CF.42786d51.svg";